import {NgModule} from '@angular/core';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {ContestHeaderComponent} from './component/contest-management/contest-header/contest-header.component';
import {SharedModule} from 'shared/shared.module';

@NgModule({
    declarations: [ContestHeaderComponent],
    imports: [
        SharedModule,
        MatProgressSpinnerModule,
    ],
    exports: [ContestHeaderComponent],
})
export class ContestPresentationModule {}
